import React from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import './Filters.css';

class Filters extends React.Component {

    constructor(props) {
        super(props);

        this.handleSlide = this.handleSlide.bind(this);

        this.state = {
            activeSlide: 0,
        };
    }

    handleSlide = () => {
        let slickSlide,
            currentSlide,
            currentSlideIndex = this.state.activeSlide,
            placeType;

        // get all the slides
        slickSlide = document.querySelectorAll('.property-detail-filters .slick-slide');
        // get the current slide
        currentSlide = slickSlide.item(currentSlideIndex);
        // get the attr data-place-type's text value
        placeType = currentSlide.querySelector('[data-place-type]').getAttribute('data-place-type');
        // update the prop
        this.props.onUpdateSelected(placeType);
    }


    render() {
        const settings = {
            arrows: false,
            slidesToShow: 6,
            variableWidth: true,
            focusOnSelect: true,
            infinite: true,
            beforeChange: (current, next) => this.setState({ activeSlide: next }),
            afterChange: () => this.handleSlide(),
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        infinite: false,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        variableWidth: false,
                        arrows: true,
                        centerMode: false,
                    },
                },
            ],
        };

        return (
            <div className='property-detail-filters'>
                <section className='section section-property-detail-filters'>
                    <div className='container'>
                        <Slider {...settings}>
                            <div id='restaurants-cafes-filter'>
                                <div className='filter' role='button' tabIndex='-1' onKeyUp={this.handleSlide} data-place-type="restaurant">
                                    RESTAURANTS & CAFES
                                </div>
                            </div>
                            <div id='bars-nightlife-filter'>
                                <div className='filter' role='button' tabIndex='-1' onKeyUp={this.handleSlide} data-place-type="bar">
                                    BARS & NIGHTLIFE
                                </div>
                            </div>
                            <div id='shopping-filter'>
                                <div className='filter' role='button' tabIndex='-1' onKeyUp={this.handleSlide} data-place-type="store">
                                    SHOPPING
                                </div>
                            </div>
                            <div id='park-filter'>
                                <div className='filter' role='button' tabIndex='-1' onKeyUp={this.handleSlide} data-place-type="park">
                                    RESIDENTIAL & PARKS
                                </div>
                            </div>
                            <div id='health-fitness-filter'>
                                <div className='filter' role='button' tabIndex='-1' onKeyUp={this.handleSlide} data-place-type="gym">
                                    HEALTH & FITNESS
                                </div>
                            </div>
                            <div id='transit-parking-filter'>
                                <div className='filter' role='button' tabIndex='-1' onKeyUp={this.handleSlide} data-place-type="transit_station">
                                    TRANSIT & PARKING
                                </div>
                            </div>
                        </Slider>
                    </div>
                </section>
            </div>
        );
    }
}

Filters.propTypes = {
    onUpdateSelected: PropTypes.func.isRequired,
};


export default Filters;

